// /src/pages/Calendar.js
import { useState } from "react";
import { useAuth } from "../lib/AuthContext.js";
import CalendarConnect from "../components/calendar/CalendarConnect.js";
import CalendarGrid from "../components/calendar/CalendarGrid.js";
import EventSidebar from "../components/calendar/EventSidebar.js";
import EventModal from "../components/calendar/EventModal.js";
import { Plus } from "lucide-react";

export default function Calendar() {
  const { user } = useAuth();
  const token = localStorage.getItem("token");
  const isConnected = !!user?.google_calendar?.access_token;

  const [events, setEvents] = useState([]);
  const [current, setCurrent] = useState({ year: new Date().getFullYear(), month: new Date().getMonth() });
  const [selected, setSelected] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);

  if (!isConnected) {
    return (
      <div className="page">
        <div className="page-header"><div className="page-title">Calendar</div></div>
        <CalendarConnect token={token} />
      </div>
    );
  }

  return (
    <div className="page">
      <div className="page-header">
        <div>
          <div className="page-title">Calendar</div>
          <CalendarConnect token={token} />
        </div>
        <button className="btn btn-primary" style={{ gap: 6 }}
          onClick={() => { setEditingEvent(null); setShowModal(true); }}>
          <Plus size={14} /> New Event
        </button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 300px", gap: 20, alignItems: "start" }}>
        <CalendarGrid
          token={token}
          current={current}
          setCurrent={setCurrent}
          selected={selected}
          setSelected={setSelected}
          events={events}
          setEvents={setEvents}
        />
        <EventSidebar
          token={token}
          current={current}
          selected={selected}
          events={events}
          setEvents={setEvents}
          onAddEvent={() => { setEditingEvent(null); setShowModal(true); }}
          onEditEvent={(event) => { setEditingEvent(event); setShowModal(true); }}
        />
      </div>

      {showModal && (
        <EventModal
          token={token}
          defaultDate={selected ? new Date(current.year, current.month, selected) : new Date()}
          event={editingEvent}
          onClose={() => { setShowModal(false); setEditingEvent(null); }}
          onSaved={(savedEvent, isEdit) => {
            setEvents(prev => isEdit
              ? prev.map(e => e.id === savedEvent.id ? savedEvent : e)
              : [...prev, savedEvent]
            );
            setShowModal(false);
            setEditingEvent(null);
          }}
        />
      )}
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}